import React from 'react';
import logo from './logo.svg';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
         
        </p>
        
      </header>
      <footer className="App-footer">Copyright 2025 Cool Ventures LLC</footer>
    </div>
  );
}

export default App;
